/* 
  This service responsible for the download functionality 
  It serves the endpoing /download/[fermentationid]
*/

import {ReadableStream} from "web-streams";
import * as fs from "filesystem";
import url from "url";
import Path from "path";
import sleep from "sleep";

class Dummy {
  constructor() {
  }
}


class DownloadService extends Dummy {
  constructor(...args) {
    super(...args);            
  }
  RM_get(event, request) {      
    var pathname = url.parse(request.url).pathname;
    var path;

    if (!pathname.startsWith("/download/"))
      return super.RM_get(event, request);


    path = pathname.replace("/download/", "/home/pi/fermentations/");
    path = Path.normalize(path);

    if (!path.startsWith("/home/pi/fermentations/")) throw new Error("Access denied");      

    if (!fs.existsSync(path)) return new Response( (new TextEncoder().encode("not found")).buffer, {
      status: 404
    } );

    var readableStream = new ReadableStream({
      MAXCHUNKSIZE: 4096,
      size: 0,
      position: 0,
      start(controller) {        
        this.size = fs.statSync(path).size;
        this.position = 0;        
      },
      async pull(controller) {
        await sleep(10);
        var chunk = fs.readFileSync(path, {
          position: this.position,
          length: this.size-this.position > this.MAXCHUNKSIZE ? this.MAXCHUNKSIZE : this.size-this.position
        });
        this.position += chunk.byteLength;       
        if (chunk.byteLength) controller.enqueue(chunk);
        if (this.position>=this.size) {          
          controller.close();
        }
      },
      cancel() {        
      }
    }, {
      highWaterMark: 1
    });       

    var response = new Response(readableStream);
    response.headers.set("Content-Type", "text/csv");
    return response;

  }      
}

export default DownloadService;